import React from 'react';
import { pxToRem } from '@withjoy/joykit/theme';
import { ButtonV2, Flex, TextV2 } from '@withjoy/joykit';

import { withWindow } from '@shared/utils/withWindow';

type ConsoleErrorStateProps = Readonly<{
  title: string;
  content: string;
  retryButtonLabel: string;
}>;

const reloadPage = () =>
  withWindow(global => {
    global.location.reload();
  });

export const ConsoleErrorState = ({ title, content, retryButtonLabel }: ConsoleErrorStateProps) => (
  <Flex
    width="100%"
    alignItems="center"
    justifyContent="center"
  >
    <Flex
      width="100%"
      textAlign="center"
      alignItems="center"
      flexDirection="column"
      paddingX={pxToRem(24)}
      paddingY={pxToRem(80)}
      maxWidth={pxToRem(320)}
      justifyContent="center"
    >
      <TextV2
        marginBottom={4}
        typographyVariant="hed5"
      >
        {title}
      </TextV2>
      <TextV2
        color="mono10"
        marginBottom={8}
        typographyVariant="body1"
      >
        {content}
      </TextV2>
      <ButtonV2
        paddingX={8}
        paddingY={4}
        shape="rounded"
        intent="neutral"
        onClick={reloadPage}
        typographyVariant="button2"
      >
        {retryButtonLabel}
      </ButtonV2>
    </Flex>
  </Flex>
);
